import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BrandS } from '@sorare/core/src/atoms/typography';
import type { Color } from '@sorare/core/src/style/types';

const Root = styled.div`
  position: relative;
  padding: var(--unit);
`;

const targetBannerAttr: Record<
  'success' | 'failed' | 'in_progress',
  { color: Color }
> = {
  success: {
    color: 'var(--c-onBase-success)',
  },
  failed: { color: 'var(--c-red-400)' },
  in_progress: { color: 'var(--c-nd-600)' },
};

const targetBannerMessages = defineMessages({
  success: { defaultMessage: 'Target hit' },
  failed: { defaultMessage: 'Target missed' },
  in_progress: { defaultMessage: 'In Progress' },
});
type Props = { targetStatus: 'success' | 'failed' | 'in_progress' | undefined };
export const TargetBanner = ({ targetStatus }: Props) => {
  if (!targetStatus) {
    return null;
  }
  const message = targetBannerMessages[targetStatus];
  const { color = 'var(--c-nd-600)' } = targetBannerAttr[targetStatus];

  return (
    <Root>
      <BrandS color={color} className="text-center">
        <FormattedMessage {...message} />
      </BrandS>
    </Root>
  );
};
